<template>
    <WH_HandoverReport-component>
        <div class="mt-5">
            <div class="mt-5">
                <div class="mt-5">
                    <b-row class="mt-5">
                        <b-col md="3">
                            <b-form-group label="From Date:"  :label-cols="4" >
                                <v-date-picker mode='single' 
                                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='select_handoverDateFrom'>
                            </v-date-picker>
                            </b-form-group>
                        </b-col>
                
                        <b-col md="3">
                            <b-form-group label="To Date:"  :label-cols="4" >
                                <v-date-picker mode='single' 
                                    input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='select_handoverDateTo'>
                                </v-date-picker>
                            </b-form-group>
                        </b-col>

                        <b-col md="4">
                            <b-form-group label="Warehouse ID" :label-cols="4">
                                <div id='container'>
                                    <ejs-multiselect  id='multi_select2'  placeholder="Select WareHouse" v-model="value_reportWH" :dataSource='options_reportWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='field_reportWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                ></ejs-multiselect>
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col md="2">
                            <b-button  @click="hanoverdeatils(handoverpageNum)" size="md" variant="primary">Search</b-button>&nbsp;&nbsp;
                            <b-button  @click="clear()" size="md" variant="danger">Clear</b-button>&nbsp;
                        </b-col>
                    </b-row>
                </div>
                
                <b-col sm="12" class="text-right">
                    <a :href="loadreporturl" target="_blank" rel="noopener noreferrer" v-if="reporttotalRows>0"><b-button variant="primary" @click="downloadcsv()">Download</b-button></a><br><br>
                    <p> <b>Total Records :<span style="color:red;"> {{reportitems1Count}}</span></b> </p>
                </b-col>
                
                <b-table show-empty responsive  :items="reportitems1"  :fields="reportfields1"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"    @filtered="onFiltered" :outlined="outlined" :busy="isBusyItem1" >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div> 
                </b-table>

                <b-col sm="12" class="text-right">
                    <p class="text-right"> <b>Total Records :<span style="color:red;"> {{reportitems2Count}}</span></b> </p>
                 </b-col>
                <b-table show-empty responsive  :items="reportitems2"  :fields="reportfields2"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"    @filtered="onFiltered" :outlined="outlined" :busy="isBusyItem2">
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div> 
                </b-table>
                <b-col sm="12" class="text-right">
                  <p> <b>Total Records :<span style="color:red;"> {{reporttotalRows}}</span></b> </p>
                </b-col>
                <b-table show-empty responsive  :items="reportitems3"  :fields="reportfields3"  :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"    @filtered="onFiltered" :outlined="outlined" :busy="isBusyItem3" >
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div> 
                </b-table>

                <b-row>
                    <b-col sm="12">
                    <paginate :page-count="reportnoofpages" :page-range="10"
                    :margin-pages="2" :click-handler="clickCallback_report"
                    :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"
                    :page-class="'page-item'"></paginate>
                    </b-col>
                </b-row>
            </div>
        </div>
    </WH_HandoverReport-component>
</template>    

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
    data() {
        return {
            select_handoverDateFrom: new Date(),
            select_handoverDateTo:new Date(),
            value_reportWH:[],
            field_reportWH:{ text: 'name', value: 'id' },
            options_reportWH:[],
            showSelectAll : true,
            isreportBusy : false,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            reportitems1 :[],
            isBusyItem1:false,
            isBusyItem2:false,
            isBusyItem3:false,
            reportitems2 :[],
            reportitems3 :[],
            reportfields1: [
                { key: 'Hub Name', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
                { key: 'Total loads pending for HubInScan', label: 'Total loads pending for HubInScan', sortable: true, sortDirection: 'desc' },
                { key: 'Total Boxes pending for HubInScan', label: 'Total Boxes pending for HubInScan', sortable: true, sortDirection: 'desc' },
            ],
            reportfields2: [
                { key: 'hub', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
                { key: 'totalLoadsHandovered', label: 'Total Loads Handovered', sortable: true, sortDirection: 'desc' },
                { key: 'totalBoxHandovered', label: 'Total Boxes Handovered', sortable: true, sortDirection: 'desc' },
                { key: 'totalHubinscanLoads', label:'Total Loads HubInScanned', sortable: true, sortDirection: 'desc' },
                { key: 'totalHubinscanBoxes', label: 'Total Boxes HubInScanned', sortable: true,sortDirection: 'desc'},    
            ],
            reportfields3: [
                { key: 'warehouseid', label: 'Warehouse ID', sortable: true, sortDirection: 'desc' },
                { key: 'Warehouse Name', label: 'Warehouse Name', sortable: true, sortDirection: 'desc' },
                { key: 'Load ID', label: 'Load ID', sortable: true, sortDirection: 'desc' },
                { key: 'accounttype', label: 'Account Type',sortable: true, sortDirection: 'desc' },
                { key: 'Invoice Amount', label: 'Invoice Amount', sortable: true, sortDirection: 'desc' },
                { key: 'AWB', label:'AWB', sortable: true, sortDirection: 'desc' },
                { key: 'Total Box Count', label: 'Total Box Count', sortable: true,sortDirection: 'desc'},
                { key: 'WH Handover Box count', label: 'WH Handover Box count', sortable: true, sortDirection: 'desc'},
                { key: 'Gap Days', label: 'Gap Days', sortable: true, sortDirection: 'desc'},
                { key: 'Gap Hours', label: 'Gap Hours', sortable: true, sortDirection: 'desc' },
                { key: 'WH Dispatch Date', label: 'WH Dispatch Date', sortable: true,sortDirection: 'desc' },
                { key: 'RB Current Status', label: 'RB Current Status', sortable: true, sortDirection: 'desc'},
                { key: 'HubInscanned Date', label: 'Hub Inscanned Date', sortable: true, sortDirection: 'desc'},
            ],
            reporttotalRows :0,
            handoverpageNum:1,
            reportnoofpages :'',
            loadreporturl :'',
            reportitems2Count:0,
            reportitems1Count:0,

        }
    },

    created() {
        let userData = localStorage.getItem('userData');
        let userInfo = JSON.parse(userData);
        this.showWHlist()
        this.hanoverdeatils(this.handoverpageNum);
    },


    methods: {
        showWHlist:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {};
          
          
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselistingforHandoverReport`, csvObj)
            .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
              
                    this.WHData  = result.body.returnvalue;
                
                    for(let j = 0; j < this.WHData.length; j++) {
                        let WH = {
                            name: this.WHData[j].warehousename ,
                            // + " - " + this.WHData[j].warehouseid ,
                            id: this.WHData[j].warehouseid,
                        }
                        this.optionsWH.push(WH);
                        this.options_reportWH.push(WH)
                    }
                
                } 
                else {
                    this.WHData  = result.body.returnvalue;
                }
                    
        
            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        downloadcsv(){
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var fromdate = (this.select_handoverDateFrom!=null)?this.formatDate(this.select_handoverDateFrom):"";
            var formatdateto=(this.select_handoverDateTo!=null)? this.formatDate(this.select_handoverDateTo):"";

            this.loadreporturl=`${CONSTANTS.MIGRATION_API_URL}/getwarehousehandoverdetailscsv?startdate=`+fromdate+`&enddate=`+formatdateto+`&warehouseid=`+(this.value_reportWH.length==0?'':this.value_reportWH)

            console.log("this.loadreporturl",this.loadreporturl)
        },

        clickCallback_report(handoverpageNum){
            this.hanoverdeatils(handoverpageNum);
        },

        hanoverdeatils(pageNo){
            this.reportitems1 =[];
            this.reportitems2 =[];
            this.reportitems3 =[];
            this.reporttotalRows =0;
            this.isBusyItem1 = true;
            this.isBusyItem2 = true;
            this.isBusyItem3 = true;
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)

            var fromdate = (this.select_handoverDateFrom!=null)?this.formatDate(this.select_handoverDateFrom):"";
            var formatdateto=(this.select_handoverDateTo!=null)? this.formatDate(this.select_handoverDateTo):"";
    
            var Obj = {
                page_no:`${pageNo}`,
                startdate : fromdate,
                enddate : formatdateto,
                warehouseid : this.value_reportWH.length==0?'':this.value_reportWH
            };
          
          
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getwarehousehandoverdetails`, Obj)
            .then(result => {
                this.isBusyItem1 = false;
                this.isBusyItem2 = false;
                this.isBusyItem3 = false;
                console.log("-------------------",result)
                if (result.body.returnmsg === 'successful') {
                    this.reportitems1 = result.body.table1;
                    this.reportitems2 = result.body.table2;
                    this.reportitems3 = result.body.table3;
                    this.reportitems1Count=this.reportitems1.length
                    this.reportitems2Count=this.reportitems2.length
                    this.reporttotalRows= result.body.totalcount;
                    this.reportnoofpages=parseInt(this.reporttotalRows)/20;
                    this.reportnoofpages=Math.ceil( this.reportnoofpages);
                
                } 
                else {
                    this.reportitems  = [];
                    this.reporttotalRows =0;
                    this.reportitems1Count=0;
                    this.reportitems2Count=0;
                }
                    
        
            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        clear(){
            this.select_handoverDateFrom = new Date();
            this.select_handoverDateTo = new Date();
            this.value_reportWH =[]
            this.hanoverdeatils(this.handoverpageNum);
        },

        formatDate: function(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");

        },
    },
}
</script>